import Vue from 'vue'
import Router from 'vue-router'
import Resource from 'vue-resource'
import Hello from '@/components/Hello'
import Home from '@/components/Home'
import Ratios from '@/components/Ratios'
import Callback from '@/components/Callback'
import Settings from '@/components/Settings'
import Logout from '@/components/Logout'
import Chart from '@/components/Chart'
import Houses from '@/components/Houses'
import Compare from '@/components/Compare'
import Print from '@/components/Print'
// import Word from '@/components/Word'

Vue.use(Resource)
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/Houses',
      name: 'Houses',
      component: Houses
    },
    {
      path: '/Ratios',
      name: 'Ratios',
      component: Ratios
    },
    {
      path: '/Compare',
      name: 'Compare',
      component: Compare
    },
    {
      path: '/Settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/Chart',
      name: 'Chart',
      component: Chart
    },
    {
      path: '/Callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/Print/:lang/:year',
      name: 'Print',
      component: Print
    },
    // {
    //   path: '/Word/:lang/:year/:tok',
    //   name: 'Word',
    //   component: Word
    // },
    {
      path: '/Logout',
      name: 'Logout',
      component: Logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js